import { observer } from 'mobx-react-lite';
import { Button, Input, Modal } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { ChangeEvent, useEffect, useState } from 'react';
import { MetaDataElement } from '../../../app/models/metaDataConfig';
import Papa from 'papaparse';
import { ReadFromCSV } from './ReadFromCSV';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';

const CutListCreationNFAI = () => {
  const {
    activityStore: { selectedActivity },
    mediaAssetStore: {
      mediaAsset: { openCutListCreation },
      setOpenCutListCreation,
    },
    userStore: { user },
    viewStore: { getCutlistDetails, itemDetails, cutlistDetails, cutlistDetailsLoader },

    metaDataStore: { WorkflowMetadataHandler },
    WorkLevelStore: {
      selectedWorkLevelItemsForName,
      loadWorkLevelBasedOnItemLevel,
    },
    viewStore: { metadata },
    TemplateStore: { loadTemplateIdForCR, selectedTemplate },
  } = useStore();
  const [csvData, setCsvData] = useState<{
    csv: string[];
    downloaded: boolean;
  }>({ csv: [], downloaded: false });
  const [csvInput, setCsvInput] = useState<any[]>([]);
  const [metadataDetails, setMetadataDetails] = useState<MetaDataElement[]>([]);
  useEffect(() => {
    loadWorkLevelBasedOnItemLevel(selectedActivity?.id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (itemDetails.parent !== null && openCutListCreation) {
      getCutlistDetails({ parentId: itemDetails.parent?.split('/')?.[0] });
    }
    // eslint-disable-next-line
  }, [itemDetails.parent, openCutListCreation]);

  useEffect(() => {
    if (cutlistDetails.elementId) {
      const tempCSV: string[] = [];
      (async () => {
        await WorkflowMetadataHandler(cutlistDetails.elementId).then(
          (Response) => {
            setMetadataDetails(Response);
            Response?.forEach((m: MetaDataElement) => {
              if (m.isActive) {
                if (
                  m.elementType !== 'Barcode' &&
                  m.elementType !== 'AddPhotograph' &&
                  m.elementType !== 'Dynamicmetadata' &&
                  m.elementType !== 'AddFiles' &&
                  m.elementType !== 'DynamicTable' &&
                  m.elementType !== "metadataFromParent"
                ) {
                  tempCSV[m.elementIndex] = `Metadata~${m.elementName}`;
                }
              }
            });
          },
        );
        setCsvData({
          ...csvData,
          csv: tempCSV.filter((m) => m !== ''),
        });
      })();

      loadTemplateIdForCR(cutlistDetails?.templateId);
    }
    // eslint-disable-next-line
  }, [cutlistDetails.elementId]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (files) {
      Papa.parse(files[0], {
        complete: function (results) {
          let reelNoIndex: number | undefined;

          if (results?.data[0]) {
            reelNoIndex = (results.data[0] as any).indexOf('Metadata~Reel No');
          } else {
            reelNoIndex = undefined;
          }

          if (reelNoIndex !== undefined) {
            let filteredData = results.data.filter(
              (row: any) => row[reelNoIndex as number] !== '',
            );
            if (filteredData.length > 251) {
              toast.error('Unable to process more than 250 reels.');
              return;
            }
            setCsvInput(filteredData);
          }
        },
      });
    }
  };

  const handleClose = () => {
    setCsvData({ ...csvData, csv: [], downloaded: false });
    setCsvInput([]);
    setOpenCutListCreation(!openCutListCreation);
  };
  return (
    <Modal
      trigger={
        <Button
          style={{
            display: user?.customerName === 'NFAIReport' ? 'auto' : 'none',
            marginTop: '8px',
          }}
        >
          {' '}
          Upload CutList Creation
        </Button>
      }
      onOpen={() => setOpenCutListCreation(!openCutListCreation)}
      open={openCutListCreation}
    >
      <Modal.Header>CutList Creation</Modal.Header>
      <Modal.Content>
        {/* {cutlistDetails.templateId !== '' ? ( */}
          <>
            <p> Click on the below button to fill in cutlist details !</p>
            <CSVLink data={[csvData.csv]} filename='Cutlist Creation'>
              <Button
                loading={cutlistDetailsLoader}
                color="teal"
                onClick={() => setCsvData({ ...csvData,csv: csvData.csv.filter((m) => m !== ''), downloaded: true })}
                >
                Download CSV
              </Button>
            </CSVLink>
          </>
        {/* ) : (
          <>
            <p>
              Oops ! We were unable to fetch the cutlist details. Please contact
              admin.
            </p>
          </> */}
        {/* )} */}
        
          <div style={{ margin: '12px 0px' }}>
            <p>Kindly Upload the File with CutList Details.</p>
            <p>
              <strong>NOTE: </strong>
            </p>
            <p>If Reel No is not found, the asset will not be created.</p>
            <p>
              Do Not Exceed 250 data. Assets more than 250 will not be created.
              Upload in chunks of 250.
            </p>
            <Input
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
            />
          </div>
        
      </Modal.Content>
      <Modal.Actions>
        {csvInput.length > 0 && (
          <Button
            loading={cutlistDetailsLoader}
            color="blue"
            onClick={() => {
              ReadFromCSV(
                csvInput,
                metadataDetails,
                selectedActivity,
                selectedTemplate,
                cutlistDetails?.assetTypeId || '',
                cutlistDetails?.elementId || '',
                cutlistDetails?.assetTypeName || '',
                cutlistDetails?.elementName || '',
                selectedWorkLevelItemsForName,
                metadata,
                cutlistDetails?.reelData,
              );
              handleClose();
            }}
          >
            Create Cutlist
          </Button>
        )}
        <Button color="black" onClick={handleClose}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default observer(CutListCreationNFAI);
